import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTebEkonomikAramaComponent} from './ctl-teb-ekonomik-arama/ctl-teb-ekonomik-arama.component';
import {TebEkonomikService} from './ctl-teb-ekonomik.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';

@Component({
  selector: 'dk-ctl-teb-ekonomik',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTebEkonomikAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TebEkonomikService],
  templateUrl: './ctl-teb-ekonomik.component.html',
  styleUrls: ['./ctl-teb-ekonomik.component.scss'],
})
export class CtlTebEkonomikComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  @Input() isReadOnly = false;
  public data: any;
  @Input() code!: string;
  @Input() period!: number;
  @Input() piHesapTuru!: number;
  @Input() harcamaKodu: number | null = null;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TebEkonomikService, private utilsService: UtilsService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period, this.piHesapTuru, this.harcamaKodu)
      }
    }
    if (changes['piHesapTuru'] || changes['harcamaKodu']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period, this.piHesapTuru, this.harcamaKodu)
        if (this.piHesapTuru === 1) this.service.getDlist('TebGelir');
        else if (this.harcamaKodu === null && this.piHesapTuru === 2) this.service.getDlist('TebGider');
      }
    }
  }

  ngOnInit(): void {
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Teb Gelir)"
      this.showAction = false
    } else if (this.code) {
      this.getData(this.code,true);
    }
    this.service.setParams(this.period, this.piHesapTuru, this.harcamaKodu)
    if (this.piHesapTuru === 1) this.service.getDlist('TebGelir');
    else if (this.harcamaKodu === null && this.piHesapTuru === 2) this.service.getDlist('TebGider');
  }

  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: string, isSetData?: boolean) {

    this.data = this.service.getData(code, this.period, this.piHesapTuru, this.harcamaKodu, isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        if (this.piHesapTuru === 1) this.code = result[0].EkoGelirKod;
        else if (this.harcamaKodu === null) this.code = result[0].EkoGiderKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst = true
      this.data = result.data;
      if (this.piHesapTuru === 1) {
        this.code = result.data.EkoGelirKod;
        this.title = result.data.Ad;
      } else if (this.harcamaKodu === null) {
        this.code = result.data.EkoGiderKod;
        this.title = result.data.Ad;
      }
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

